import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import App from './App';
import './index.scss';
import * as Sentry from '@sentry/react';
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; //PWA
serviceWorkerRegistration.unregister();
if (!window.location.hostname.includes('localhost'))
  Sentry.init({
    dsn: 'https://dd4f783e459c5aee1b4a1c9187312ea9@sentry.shorton.kr/20',
    // 성능 모니터링 설정
    integrations: [
      Sentry.browserTracingIntegration(),
      // Session Replay: 사용자 행동 재현 기능
      Sentry.replayIntegration({
          // 개인정보 보호를 위해 모든 텍스트를 가립니다.
          maskAllText: false,
          // 모든 CSS 인풋(input) 요소를 가립니다.
          blockAllMedia: false,
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,
    // Session Replay 수집 비율
    // 전체 세션의 10%를 녹화
    replaysSessionSampleRate: 0.1,
    // 에러가 발생한 세션은 100% 녹화
    replaysOnErrorSampleRate: 1.0,
    environment: 'WEB'
  });

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
